export default function isOnline() {
    if (typeof navigator.onLine !== 'undefined') {
        return navigator.onLine;
    }
    // always assume it's online
    return true;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/swr/esm/libs/is-online.js
// module id = 52
// module chunks = 0 1 2 3